import { useLanguage } from "../../i18n/LanguageContext";

// The same stopwatch mark used for the favicon/app icon, inlined so it
// stays crisp at any size and needs no extra network request.
export default function Logo({ size = 34, className }) {
  const { t } = useLanguage();
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 100 100"
      role="img"
      aria-label={t("common.logo")}
    >
      <rect x="0" y="0" width="100" height="100" rx="22" fill="#2E2A22" />
      <rect x="42" y="6" width="16" height="11" rx="4" fill="#9A4B4F" />
      <circle
        cx="50"
        cy="58"
        r="31"
        fill="none"
        stroke="#FFFBF2"
        strokeWidth="9"
      />
      <circle
        cx="50"
        cy="58"
        r="31"
        fill="none"
        stroke="#9A4B4F"
        strokeWidth="9"
        strokeDasharray="58 195"
        strokeLinecap="butt"
        transform="rotate(-90 50 58)"
      />
      <line
        x1="50"
        y1="58"
        x2="50"
        y2="34"
        stroke="#FFFBF2"
        strokeWidth="5"
        strokeLinecap="round"
      />
      <circle cx="50" cy="58" r="5.5" fill="#9A4B4F" />
    </svg>
  );
}
